import React, { useState } from 'react';
import { Box, ToggleButton } from '@mui/material';
import Icon from '@mui/material/Icon';
import { SvgIconComponent } from '@mui/icons-material';
import {AnimatedLayerName} from "./AnimatedLayer.tsx";

interface ToolbarButtonProps {
    id: string;
    name: string;
    toggledOn: boolean;
    enabled: boolean;
    onClick: () => void;
    icon: string | SvgIconComponent | React.ReactNode;
    labelSide?: string; // Changed labelSide to a required property
}

const ToolbarButton: React.FC<ToolbarButtonProps> = ({
    id,
    name,
    toggledOn,
    enabled,
    onClick,
    icon,
    labelSide
}) => {
    const [hoveredLayer, setHoveredLayer] = useState<string | null>(null);

    const renderIcon = () => {
        if (typeof icon === 'string') {
            return <Icon>{icon}</Icon>;
        }
        if (typeof icon === 'function') {
            const IconComponent = icon as SvgIconComponent;
            return <IconComponent />;
        }
        return icon;
    };

    return (
        <Box
            key={id}
            sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                margin: '10px'
            }}
            onMouseEnter={() => setHoveredLayer(id)}
            onMouseLeave={() => setHoveredLayer(null)}
        >
            <ToggleButton
                disabled={!enabled}
                onClick={onClick}
                value={id}
                aria-label={id}
                sx={{
                    color: toggledOn ? '#fff' : 'gray',
                    borderRadius: '50%',
                    border: 'none',
                    backgroundColor: enabled ? '#00d4ad' : '#aaa',
                    "&:hover": {
                        backgroundColor: "#faad17",
                    },
                    "&:focus": {
                        outline: "none",
                        boxShadow: "none",
                    }
                }}

            >
                {renderIcon()}
            </ToggleButton>
            {hoveredLayer === id && (
                <AnimatedLayerName side={labelSide ?? 'left'}>
                    {name}
                </AnimatedLayerName>
            )}
        </Box>
    );
}


export default ToolbarButton;
